module.exports = __webpack_public_path__ + "static/media/backarrowblue.3d6fc2d8.svg";